import React from 'react';

import Main from 'pages/Layout/Main';
import Landing from 'pages/Modules/Landing/Landing';
import { useSelector } from 'react-redux';
import { roleSettingsSelector } from 'redux/slices/app/authSlice';
import { hasPermission } from 'utils/helper';
import { permissions } from 'constant/permissions';
import DeliveryMethod from 'pages/Modules/DeliveryMethod/DeliveryMethod';

const DeliveryMethodView = () => {
  const roleSettingsInfo = useSelector(roleSettingsSelector);

  return (
    <Main>
      {hasPermission(
        permissions.deliveryTypeDefinition,
        'VIEW',
        roleSettingsInfo
      ) ? (
        <DeliveryMethod />
      ) : (
        <Landing />
      )}
    </Main>
  );
};

export default DeliveryMethodView;
